export default "__VITE_ASSET__nbdyEigT__"